import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import ChooseSubscriptionPlanComponent from 'components/ChooseSubscriptionPlan/ChooseSubscriptionPlan';
import { Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import deliveryAddress from 'state/address';
import { chosenAgreement as chosenAgreementAtom } from 'state/agreement';
import { selectedSubscriptionPlan } from 'state/subscriptionPlan';
import { SubscriptionPlan } from 'utils/mapping/mapSubscriptionPlan';
export default function ChooseSubscriptionPlan() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const chosenAgreement = useRecoilValue(chosenAgreementAtom);
  const address = useRecoilValue(deliveryAddress);
  const [subscriptionPlan, setSubscriptionPlan] = useRecoilState(selectedSubscriptionPlan);

  // Determine default subscription plan based on address
  useEffect(() => {
    const getDefaultSubscriptionPlan = () => {
      // Priority order: delivery address -> agreement address -> customer address
      const addressToCheck = address || chosenAgreement?.shippingAddress || customer?.shippingAddress || customer?.customerAddress;

      // Check if address is Norwegian (country code 'NO' or 'nb')
      const isNorwegianAddress = addressToCheck?.countryCode === 'NO' || addressToCheck?.countryCode === 'nb';
      return isNorwegianAddress ? SubscriptionPlan.Standard : SubscriptionPlan.Basic;
    };
    const defaultPlan = getDefaultSubscriptionPlan();
    setSubscriptionPlan(defaultPlan);
  }, [address, chosenAgreement, customer, setSubscriptionPlan]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, t('register_vehicle.select_subscription_plan')), /*#__PURE__*/React.createElement(ChooseSubscriptionPlanComponent, {
    selectedPlan: subscriptionPlan,
    onPlanSelect: setSubscriptionPlan
  }));
}